function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M188509 278787l-53423-50805-54880 49568c-1211 1318-2949 2144-4880 2144-3661 0-6628-2967-6628-6628V164847L2054 101469c-2645-2516-2750-6702-233-9347 852-895 1895-1499 3004-1809l-1-3L324930 247c3517-986 7169 1066 8156 4583 505 1799 214 3633-660 5127L198970 276948c-1630 3260-5595 4581-8855 2952-601-301-1136-680-1598-1120l-7 7zm-63015-59927l-43540-41406v80733l43540-39327zm-49143-64981L283394 25676 19589 99898l56762 53980zM310407 24483L86244 163286l104911 99770L310407 24482z",
  fillRule: "nonzero"
});

var SvgNavbarContact = function SvgNavbarContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 333333 280599",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavbarContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navbar_contact.7dffc8b3.svg";
export { ForwardRef as ReactComponent };